const FINISH_LOADING = 'FINISH_LOADING';
const START_LOADING = 'START_LOADING';

export { FINISH_LOADING, START_LOADING };
